import React from 'react';
import Routes from './routes/Index';

const AppMain = props => <>{Routes}</>;
export default AppMain;